import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=709a4a06&scoped=true"
import script from "./addTag.vue?vue&type=script&lang=js"
export * from "./addTag.vue?vue&type=script&lang=js"
import style0 from "./addTag.vue?vue&type=style&index=0&id=709a4a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a4a06",
  null
  
)

export default component.exports